module.exports = __webpack_public_path__ + "excel.svg?c168c70f21119396579bc0810ff5dce0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/excel.svg
// module id = 1246
// module chunks = 2